import { useFeatureConfiguration } from "@tudigo-monorepo/tudigo-session";
import {
  ComparatorClear,
  ComparatorModeTrigger,
} from "@tudigo-monorepo/web-tudigo-comparator";
import {
  UI_PROJECTS_COMPARATOR_MODAL_OPENED,
  UI_PROJECTS_COMPARATOR_STARTED,
} from "@tudigo-monorepo/web-tudigo-tracking";

import { useProjectsComparatorCustomerTracking } from "../../hooks/use-projects-comparator-customer-tracking";

export function ProjectsComparatorActions() {
  const { enabled } = useFeatureConfiguration("comparator");
  const { comparatorStatePayload, customerTrackComparator } =
    useProjectsComparatorCustomerTracking();

  return (
    <div className="flex items-center gap-3">
      <ComparatorClear />

      {enabled && (
        <ComparatorModeTrigger
          className="h-10 w-full !p-3"
          onUpdate={(mode) => {
            if (mode === "selection") {
              customerTrackComparator(UI_PROJECTS_COMPARATOR_STARTED);
            }
            if (mode === "comparison") {
              customerTrackComparator(
                UI_PROJECTS_COMPARATOR_MODAL_OPENED,
                comparatorStatePayload,
              );
            }
          }}
        />
      )}
    </div>
  );
}
